import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			La Bildo pritaksas la vivan naturon:
		</p>
		
		<p class="mb-3">
			- Ĉio ĉi, certe, ne tute fuŝa estas: kaj la fono, kaj la perspektivo. 
			Sed devas ja ekzisti certa kadro!
		</p>
		`
	)
}

const itemName = {
	esp: 'La bildo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;